//DO NOT REMOVE React DECLARATION
import React from 'react';
import { Grid } from '@mui/material';

export const formatCpoIdWithName = (operators, cpoIdSelected) => {
  if (!cpoIdSelected) return '';
  const op = operators?.find((o) => o?.cpoId === cpoIdSelected);
  return op ? `${op.cpoId} : ${op.cpoName}` : cpoIdSelected;
};

export const translatePaymentMethod = (
  t,
  paymentMethodsTypes,
  paymentMethodSelected
) => {
  if (!paymentMethodSelected) return '';
  const pm = paymentMethodsTypes?.find(
    (p) => p?.value === paymentMethodSelected
  );
  return pm ? t(pm.translationKey) : paymentMethodSelected;
};
export const formatLocationIdWithName = (
  stationsWithCpo,
  selectedLocationIds
) => {
  return selectedLocationIds
    .map((id) => {
      const loc = stationsWithCpo?.find((s) => s.locationId === id);
      return loc ? `${loc.locationId}: ${loc.locationName}` : id;
    })
    .join(', ');
};
// helper: consistent label + control row
export const DownloadCenterFieldRow = ({ label, children }) => (
  <Grid container spacing={2} alignItems="center" sx={{ mt: 3 }}>
    <Grid item xs={12} sm={6} md={4} lg={5}>
      <div>{label}</div>
    </Grid>
    <Grid item xs={12} sm={6} md={4} lg={6}>
      {children}
    </Grid>
  </Grid>
);
export const translateChargingType = (
  t,
  chargingTypeModes,
  chargingTypeSelected
) => {
  if (!chargingTypeSelected) return '';
  const pm = chargingTypeModes?.find((p) => p?.value === chargingTypeSelected);
  return pm ? t(pm.translationKey) : chargingTypeSelected;
};
